import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { IconBlob } from "@/components/IconBlob";
import { useApp } from "@/context/AppContext";
import { usePageMeta } from "@/lib/seo";
import { ArrowLeft, ArrowRight } from "lucide-react";

function SubTile({ cat, sub, label, onClick }) {
  return (
    <button data-testid={`need-sub-${sub ? sub.slug : cat.slug}`} onClick={onClick}
      className="group text-left bg-white rounded-[18px] p-4 flex gap-3 items-center">
      <IconBlob icon={cat.icon} seed={sub?.slug || cat.slug} />
      <span className="flex-1 min-w-0 text-base font-extrabold text-[#0F1230] leading-tight">{label}</span>
      <ArrowRight size={18} className="text-[#1F4FE0] group-hover:translate-x-1 transition-transform duration-150" />
    </button>
  );
}

export default function MacroNeed() {
  const { macro } = useParams();
  const navigate = useNavigate();
  const { categories, catName, getMacro, macrosLoading } = useApp();
  const m = getMacro(macro);
  const cats = categories.filter((c) => m && m.cats.includes(c.slug));
  const single = cats.length === 1 ? cats[0] : null;
  usePageMeta(m?.label, single?.description);

  if (macrosLoading) return <Layout><p className="text-[#4A4E68]">Caricamento...</p></Layout>;
  if (!m) return <Layout><p className="text-[#4A4E68]">Area non trovata.</p></Layout>;

  const subs = single ? (single.subcategories || []) : [];
  return (
    <Layout>
      <button onClick={() => navigate("/")} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Home</button>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-1">{m.label}</h1>
      {single?.description && <p data-testid="macro-description" className="text-sm text-[#2A2E48] mb-2 max-w-2xl">{single.description}</p>}
      <p className="text-sm text-[#4A4E68] mb-4">Scegli il tipo di richiesta.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {single && subs.length > 0 && subs.map((s) => (
          <SubTile key={s.slug} cat={single} sub={s} label={catName(s)} onClick={() => navigate(`/publish/${single.slug}?sub=${s.slug}`)} />
        ))}
        {single && subs.length === 0 && (
          <SubTile cat={single} label="Descrivi la tua richiesta" onClick={() => navigate(`/publish/${single.slug}`)} />
        )}
        {!single && cats.map((c) => (
          <SubTile key={c.slug} cat={c} label={catName(c)} onClick={() => navigate(`/publish/${c.slug}`)} />
        ))}
      </div>
    </Layout>
  );
}
